import { render, staticRenderFns } from "./data27.vue?vue&type=template&id=ef439572&scoped=true&"
import script from "./data27.vue?vue&type=script&lang=js&"
export * from "./data27.vue?vue&type=script&lang=js&"
import style1 from "./data27.vue?vue&type=style&index=1&id=ef439572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef439572",
  null
  
)

export default component.exports